import { Button, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useDialogBetter } from "../../../hooks/useDialogBetter";
import ConfirmCustomerAnonymizationDialog from "./ConfirmCustomerAnonymizationDialog";
import VoiceOverOffIcon from '@mui/icons-material/VoiceOverOff';

export const AnonymizeCustomerDialogButton = (props) => {
    const { customerId} = props;
    const { t } = useTranslation();
    const { openDialog } = useDialogBetter();

    const handleOpenDialog = () => {
        openDialog({
            Component: ConfirmCustomerAnonymizationDialog,
            componentProps: {
                customerId: customerId,
            },
        });
    };

    return (
        <Button
            variant="outlined"
            startIcon={<VoiceOverOffIcon />}
            disabled={false}
            // fullWidth
            onClick={handleOpenDialog}
        >
            {t("clients.PersonClausesDialog.anonymizeButtonLabel")}
        </Button>
    );
};